<script>
  import FloatInput from '#lib/FloatInput.svelte';
  import { format_price } from '#lib/patch_util.js';

  let {
    /** @type {string} */
    id,
    ref = $bindable(),
    /** @type {number} */
    value = $bindable(),
    /** @type {string} */
    placeholder,
    /** @type {string} */
    currency,
    /** @type {string} e.g. "de-DE" */
    locale,
    /** @type {boolean} */
    disabled,
    /** @type {number} */
    min = -Number.MAX_SAFE_INTEGER,
    /** @type {number} */
    max = Number.MAX_SAFE_INTEGER,
    /** @type {function} */
    onenter,
    /** @type {function} */
    onblur,
    /** @type {function} */
    onchange,
    /** @type {function} */
    onkeydown,
    /** @type {string} */
    variant = 'brand outlined',
    /** @type {text-heading1|text-heading2|text-heading3|text-body|text-controls|text-preamble|text-caption|text-control} */
    text_style = 'text-control',
    /** @type {string} */
    class: css_class,
  } = $props();

  // Hide currency symbol when input is focused
  let is_focused = $state(false);

  // Convert cents to decimal for display - make this reactive to value changes
  let decimal_value = $derived.by(() => {
    return value === undefined ? undefined : value / 100;
  });

  function handle_float_input_change(input_value) {
    // FloatInput passes a number (or undefined), not a string
    if (input_value === undefined || input_value === null) {
      value = undefined;
    } else {
      // Convert decimal value to cents (integer)
      value = Math.round(input_value * 100);
    }
    onchange?.(value);
  }
</script>

<div class="price-input full-width flex-row items-center {css_class}">
  <!-- only show the currency symbol (and only in case of value) -->
  {#if currency && value !== undefined && !is_focused}
    <label 
      class="currency-symbol leading-trim {text_style} {disabled ?  '' : 'text-3'}"
      title={currency}
      for={id}
    >
      {new Intl.NumberFormat(locale || 'de-DE', { style: 'currency', currency: currency || 'EUR' }).formatToParts(0).find(p => p.type === 'currency')?.value || '€'}
    </label>
  {/if}
  <FloatInput
    {id}
    bind:ref={ref}
    value={decimal_value}
    {placeholder}
    min={min / 100}
    max={max / 100}
    {onkeydown}
    {onenter}
    {variant}
    {text_style}
    class="full-width"
    {disabled}
    onfocus={() => is_focused = true}
    onblur={() => {
      is_focused = false;
      onblur?.();
    }}
    onchange={handle_float_input_change}
  />
</div>

<style lang='postcss'>
  .currency-symbol {
    text-align: center;
    width: 1em;
    :global(&:has(+ input)){
      padding-inline-start: calc(var(--input-inline-spacing));
    }
    :global(& + input) {
      padding-inline-start: 1ch;
    }
  }
</style>